import { render, staticRenderFns } from "./appFoot.vue?vue&type=template&id=393a0880&scoped=true&"
import script from "./appFoot.vue?vue&type=script&lang=js&"
export * from "./appFoot.vue?vue&type=script&lang=js&"
import style0 from "./appFoot.vue?vue&type=style&index=0&id=393a0880&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "393a0880",
  null
  
)

export default component.exports